import React from 'react'
import { Route, Switch } from 'react-router-dom'
import { AnnouncementsIndex } from './screens/Index'


function AnnouncementsRoutes() {
  return (
    <Switch>
      <Route component={AnnouncementsIndex} />
    </Switch>
  )
}

export { AnnouncementsRoutes }
